import { graphql, useStaticQuery } from 'gatsby';
import { NavSection } from './use-footer-navigation';

type Props = {
  allNavTop: {
    nodes: NavSection[];
  };
};

export const useTopNavigation = () => {
  const data = useStaticQuery<Props>(graphql`
    query {
      allNavTop {
        nodes {
          section {
            heading {
              name
              nameLg
              icon
              iconLg
              link
            }
            items {
              name
              nameLg
              icon
              iconLg
              link
              isExternal
            }
          }
          heading {
            name
            nameLg
            icon
            iconLg
            link
          }
          items {
            name
            nameLg
            icon
            iconLg
            link
            isExternal
          }
        }
      }
    }
  `);

  return data.allNavTop.nodes.map((x) => x.section || x);
};
